const getTextLabel = ({
  active,
  isEligibleForRentGuarantee,
  isEnabledForRentGuarantee,
  isFreemiumEnabled,
  isScreenMobile,
  isSelfServeOnboardingInProgress,
  isWaitlistButton,
  isWaitlisted,
  shouldAutoActivate,
}: {
  active: boolean;
  isEligibleForRentGuarantee: boolean;
  isEnabledForRentGuarantee: boolean;
  isFreemiumEnabled: boolean;
  isScreenMobile: boolean;
  isSelfServeOnboardingInProgress: boolean;
  isWaitlistButton: boolean;
  isWaitlisted: boolean;
  shouldAutoActivate: boolean;
}) => {
  if (isWaitlistButton) {
    return isWaitlisted ? 'End waitlist' : 'Start waitlist';
  }

  const canAccessRentalProtectionReactivationExperience = isEligibleForRentGuarantee && !isEnabledForRentGuarantee;
  const shouldShowRentGuaranteeText = !active && canAccessRentalProtectionReactivationExperience;

  const shouldShowPremiumText = !active && isFreemiumEnabled;

  if (shouldShowRentGuaranteeText || shouldShowPremiumText) {
    if (shouldShowPremiumText && shouldAutoActivate && !canAccessRentalProtectionReactivationExperience) {
      return 'Publish';
    }

    return 'Activate listing';
  }

  if (isSelfServeOnboardingInProgress) {
    return 'Submit listing ';
  }

  const buttonText = active ? 'Deactivate' : 'Publish';

  return isScreenMobile ? buttonText : `${buttonText} listing`;
};

const getIsButtonDisabled = ({
  isNotActiveAndUpdateActiveStatusNotAllowed,
  isPaidMultifamily,
  isPublishedDisabled,
  isSelfServeOnboardingInProgress,
  isUpdateRestricted,
  isWaitlistButton,
  features,
}: {
  isNotActiveAndUpdateActiveStatusNotAllowed: boolean;
  isPaidMultifamily: boolean;
  isPublishedDisabled: boolean;
  isSelfServeOnboardingInProgress: boolean;
  isUpdateRestricted: boolean;
  isWaitlistButton: boolean;
  features: { canUpdateListing: boolean };
}) => {
  if (
    (isWaitlistButton && features.canUpdateListing) ||
    isPaidMultifamily ||
    (isSelfServeOnboardingInProgress && !isUpdateRestricted && !isPublishedDisabled)
  ) {
    return false;
  }

  return isNotActiveAndUpdateActiveStatusNotAllowed || isPublishedDisabled;
};

export const getCTAButtonArgs = ({
  active,
  isEligibleForRentGuarantee,
  isEnabledForRentGuarantee,
  isFreemiumEnabled,
  isNotActiveAndUpdateActiveStatusNotAllowed,
  isPackageProduct,
  isPaidMultifamily,
  isPublishedDisabled,
  isScreenMobile,
  isSelfServeOnboardingInProgress,
  isUpdateRestricted,
  isWaitlisted,
  shouldAutoActivate,
  adproduct,
  features,
  productType,
  waitlistEligibleProductTypes,
}: {
  active: boolean;
  isEligibleForRentGuarantee: boolean;
  isEnabledForRentGuarantee: boolean;
  isFreemiumEnabled: boolean;
  isNotActiveAndUpdateActiveStatusNotAllowed: boolean;
  isPackageProduct: boolean;
  isPaidMultifamily: boolean;
  isPublishedDisabled: boolean;
  isScreenMobile: boolean;
  isSelfServeOnboardingInProgress: boolean;
  isUpdateRestricted: boolean;
  isWaitlisted: boolean;
  shouldAutoActivate: boolean;
  adproduct: { isUnpaid: boolean };
  features: { canUpdateListing: boolean };
  productType: string;
  waitlistEligibleProductTypes: Array<string>;
}) => {
  const isWaitlistButton =
    (isPackageProduct || waitlistEligibleProductTypes.includes(productType) || adproduct.isUnpaid) && active;

  return {
    textLabel: getTextLabel({
      active,
      isEligibleForRentGuarantee,
      isEnabledForRentGuarantee,
      isFreemiumEnabled,
      isScreenMobile,
      isSelfServeOnboardingInProgress,
      isWaitlistButton,
      isWaitlisted,
      shouldAutoActivate,
    }),
    isButtonDisabled: getIsButtonDisabled({
      isNotActiveAndUpdateActiveStatusNotAllowed,
      isPaidMultifamily,
      isPublishedDisabled,
      isSelfServeOnboardingInProgress,
      isUpdateRestricted,
      isWaitlistButton,
      features,
    }),
  };
};
